import styles from './OrdersScreen.module.css';
import helpers from './helpers.js';
import {useState, useContext, useEffect} from 'react';
import { UserContext } from './UserContext.js';

import ScreenHeader from "./components/ScreenHeader.js";
import Module from "./components/Module.js";
import TextInput from "./components/TextInput.js";
import Button from "./components/Button.js";
import FAQ from "./components/support/FAQ.js";

const ordersArray = [
  {
    id: "",
    status: "delivered",
    deliveryDate: "",
    pincharBags: "",
    pelletcharBags: "",
    weight: "",
    volume: ""
  }
]

function OrdersScreen(props) {
  const {user, setUser} = useContext(UserContext);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [orders, setOrders] = useState([]);
  console.log("OrdersScreen Rendered");
  useEffect(() => {
    console.log("Fetching Orders")
    const fetchOrders = async () => {
      // Validate user and token before making request
      if (!user || !user.token || !user.details || !user.details.id) {
        console.error("User not properly authenticated or missing user details");
        setOrders([]);
        return;
      }

      try {
        const request = {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          }
        };
        
        console.log("Making request to:", user.backEndURL + "/orders");
        console.log("User ID:", user.details.id);
        
        let response = await fetch(user.backEndURL + "/orders", request);
        let jsonResponse = await response.json();
        
        console.log("Response status:", response.status);
        console.log("Response data:", jsonResponse);
        
        if (jsonResponse.success) {
          console.log("Orders fetched successfully:", jsonResponse.data);
          let newOrders = [];
          
          if (jsonResponse.data && Array.isArray(jsonResponse.data)) {
            jsonResponse.data.forEach((order) => {
              console.log("Processing order:", order);

              // Skip orders with destination_type "site"
              if (order.destination_type === "site") {
                console.log("Skipping order with destination_type 'site':", order.id);
                return;
              }

              let orderDate = new Date(order.delivery_date)
              let day = orderDate.getDate().toString().padStart(2, '0');
              let month = (orderDate.getMonth() + 1).toString().padStart(2, '0');
              let year = orderDate.getFullYear();
              let dateString = day + "/" + month + "/" + year;
              let newOrder = {
                id: order.order_id || order.id || order._id,
                status: order.status,
                deliveryDate: dateString,
                pincharBags: order.products[0]?.amount || 0,
                pelletcharBags: order.products[1]?.amount || 0,
                weight: Math.round((order.products[0]?.amount || 0) * 0.32 * 10)/10,
                volume: (order.products[0]?.amount || 0) * 2
              }
              newOrders.push(newOrder);
            })
          }
          
          setOrders(newOrders);
          console.log("Orders processed successfully:", newOrders.length, "orders");
        } else {
          console.error("API Error:", jsonResponse.message || "Unknown error");
          console.error("Full response:", jsonResponse);
          setOrders([]);
        }
      } catch (error) {
        console.error("Network or parsing error:", error);
        setOrders([]);
      }
    }
    fetchOrders();
  },[user])

  const renderOrders = () => {
    let filteredOrders = [];
    if(selectedFilter === "all"){
      filteredOrders = orders;
    } else {
        filteredOrders = orders.filter(function (order) {
        return order.status === selectedFilter
      });
    }

    // Show message if no orders
    if (filteredOrders.length === 0) {
      return (
        <tr className={styles.emptyRow}>
          <td colSpan="7" className={styles.emptyMessage}>
            {orders.length === 0 ? 'No deliveries found. Your deliveries will appear here once they are scheduled.' : `No ${selectedFilter} deliveries found.`}
          </td>
        </tr>
      );
    }

    const renderStatus = (status) => {
      switch(status){
        case "delivered":
          return <td className={styles.statusDelivered}><span className={styles.statusIcon}>check-circle</span>Delivered</td>
        case "upcoming":
          return <td className={styles.statusUpcoming}><span className={styles.statusIcon}>arrow-circle-right</span>Upcoming</td>
        case "cancelled":
          return <td className={styles.statusCancelled}><span className={styles.statusIcon}>times-circle</span>Cancelled</td>
        default:
            return <td>N/A</td>
      }
    }

    return(
      <>
        {filteredOrders.map(order => {
          console.log(order);
          return(
            <tr className={styles.tableRow} key={order.id}>
              <td className={styles.dataBold}>#{order.id}</td>
              {renderStatus(order.status)}
              <td>{order.deliveryDate}</td>
              <td><span className={styles.dataBold}>{order.pincharBags} </span>Bags</td>
              <td><span className={styles.dataBold}>{order.pelletcharBags} </span>Bags</td>
              <td><span className={styles.dataBold}>{order.weight} </span>tons</td>
              <td><span className={styles.dataBold}>{order.volume}</span> m<span className={styles.exp}>3</span></td>
            </tr>
          ) 
        })
      }
      </>
    )
  }

  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader iconName="FaTruck" name={"Deliveries"} content={"Browse through your biochar deliveries. Don't hesitate to contact us if you have any questions!"}/>
          <div className={"contentGrid"}>
            <Module spanColumn={24} spanRow={5} height={"100%"}>
              <div className={styles.headerRow}>
                <div onClick={() => setSelectedFilter("all")} className={helpers.clx(styles.headerFilter, selectedFilter === "all" ? styles.headerFilterSelected : "")}>
                  All
                </div>
                <div onClick={() => setSelectedFilter("delivered")} className={helpers.clx(styles.headerFilter, selectedFilter === "delivered" ? styles.headerFilterSelected : "")}>
                  Delivered
                </div>
                <div onClick={() => setSelectedFilter("upcoming")} className={helpers.clx(styles.headerFilter, selectedFilter === "upcoming" ? styles.headerFilterSelected : "")}>
                  Upcoming
                </div>
                <div onClick={() => setSelectedFilter("cancelled")} className={helpers.clx(styles.headerFilter, selectedFilter === "cancelled" ? styles.headerFilterSelected : "")}>
                  Cancelled
                </div>
              </div>
              <div className={styles.tableContainer}>
                <table className={styles.table}>
                  <thead>
                    <tr className={styles.tableHeaderRow}>
                      <th>Order ID</th>
                      <th>Status</th>
                      <th>Delivery Date</th>
                      <th>PinChar</th>
                      <th>PelletChar</th>
                      <th>Weight</th>
                      <th>Volume</th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderOrders()}
                  </tbody>
                </table>
              </div>
            </Module>
          </div>
    </div>
  );
}

export default OrdersScreen;